<span class="content-wrapper">
  <ng-content></ng-content>
</span>
<span class="focus-overlay"></span>
